import DockerNetworkHelper from 'Docker/helpers/networkHelper';

angular.module('shbdeployer.docker').controller('NetworkController', [
  '$scope',
  '$state',
  '$transition$',
  '$filter',
  'NetworkService',
  'Container',
  'Notifications',
  'HttpRequestHelper',
  'NetworkHelper',
  function ($scope, $state, $transition$, $filter, NetworkService, Container, Notifications, HttpRequestHelper, NetworkHelper) {
    $scope.removeNetwork = function removeNetwork() {
      NetworkService.remove($transition$.params().id, $transition$.params().id)
        .then(function success() {
          Notifications.success('Сеть удалена', $transition$.params().id);
          $state.go('docker.networks', {});
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось удалить сеть');
        });
    };

    $scope.containerLeaveNetwork = function containerLeaveNetwork(network, container) {
      HttpRequestHelper.setPortainerAgentTargetHeader(container.NodeName);
      NetworkService.disconnectContainer($transition$.params().id, container.Id, false)
        .then(function success() {
          Notifications.success('Контейнер отключен от сети', $transition$.params().id);
          $state.go('docker.networks.network', { id: network.Id }, { reload: true });
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось отключить контейнер от сети');
        });
    };

    $scope.isSystemNetwork = function () {
      return $scope.network && NetworkHelper.isSystemNetwork($scope.network);
    };

    $scope.allowRemove = function () {
      return !$scope.isSystemNetwork();
    };

    function filterContainersInNetwork(network, containers) {
      var containersInNetwork = [];
      containers.forEach(function (container) {
        var containerInNetwork = network.Containers[container.Id];
        if (containerInNetwork) {
          containerInNetwork.Id = container.Id;
          // В Docker 1.9 имя контейнера в описании сети отсутствует
          if (!containerInNetwork.Name) {
            containerInNetwork.Name = $filter('trimcontainername')(container.Names[0]);
          }
          containersInNetwork.push(containerInNetwork);
        }
      });
      $scope.containersInNetwork = containersInNetwork;
    }

    function getContainersInNetwork(network) {
      var apiVersion = $scope.applicationState.endpoint.apiVersion;
      if (network.Containers) {
        if (apiVersion < 1.24) {
          Container.query(
            {},
            function success(data) {
              var containersInNetwork = data.filter(function filter(container) {
                if (container.HostConfig.NetworkMode === network.Name) {
                  return container;
                }
              });
              filterContainersInNetwork(network, containersInNetwork);
            },
            function error(err) {
              Notifications.error('Ошибка', err, 'Не удалось получить список контейнеров в сети');
            }
          );
        } else {
          Container.query(
            {
              filters: { network: [$transition$.params().id] },
            },
            function success(data) {
              filterContainersInNetwork(network, data);
            },
            function error(err) {
              Notifications.error('Ошибка', err, 'Не удалось получить список контейнеров в сети');
            }
          );
        }
      }
    }

    function initView() {
      var nodeName = $transition$.params().nodeName;
      HttpRequestHelper.setPortainerAgentTargetHeader(nodeName);
      $scope.nodeName = nodeName;
      NetworkService.network($transition$.params().id)
        .then(function success(data) {
          $scope.network = data;
          getContainersInNetwork(data);
          $scope.network.IPAM.IPV4Configs = DockerNetworkHelper.getIPV4Configs($scope.network.IPAM.Config);
          $scope.network.IPAM.IPV6Configs = DockerNetworkHelper.getIPV6Configs($scope.network.IPAM.Config);
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось получить сведения о сети');
        });
    }

    initView();
  },
]);
